import { render, staticRenderFns } from "./DeliverySummaryPerRawMaterial.vue?vue&type=template&id=3005b090"
import script from "./DeliverySummaryPerRawMaterial.vue?vue&type=script&lang=js"
export * from "./DeliverySummaryPerRawMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports